export default function isSesi(): boolean {
  return window.location.origin.toLowerCase().includes("sesi");
}
